import {setMessage, isVisible} from './message'
import {setLoadingStatus} from './loaderAction';
export const setProducts = (data) => {
    return {
        type: 'SET_PRODUCTS',
        payload : data
    }
}

export const getAllProducts = (url) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'ProductReducer', status: true}))
        fetch(url + '/api/products/action/getAllProducts')
        .then((response) => {

            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            dispatch(setLoadingStatus({reducer: 'ProductReducer', status: false}))
            dispatch(setProducts(data))

        })
        .catch((error) => {

            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/product.js